import { render, staticRenderFns } from "./PublicPerson.vue?vue&type=template&id=f026c31c&scoped=true"
import script from "./PublicPerson.vue?vue&type=script&lang=js"
export * from "./PublicPerson.vue?vue&type=script&lang=js"
import style0 from "./PublicPerson.vue?vue&type=style&index=0&id=f026c31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f026c31c",
  null
  
)

export default component.exports